export default {
    state: {
        list: null,
        count: null,
        filters: {
            search: '',
            orderBy: 'IP',
            desc: false,
        },
    },

    mutations: {
        IPFIREWALL_SET_LIST(state, list) {
            state.list = list
        },

        IPFIREWALL_SET_COUNT(state, count) {
            state.count = count
        },

        IPFIREWALL_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value,
            }
        },
        SET_IPFIREWALL_LIST(state, list) {
            state.list = list
        },

        IPFIREWALL_RESET_FILTERS(state){
            state.filters = {
                search: '',
                orderBy: 'ip',
                desc: false,
            }
        },

    },
}
